var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuSymozxSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.21875C10 9.42595 10.0823 9.62466 10.2288 9.77118C10.3753 9.91769 10.574 10 10.7812 10C10.9885 10 11.1872 9.91769 11.3337 9.77118C11.4802 9.62466 11.5625 9.42595 11.5625 9.21875C11.5625 9.01155 11.4802 8.81284 11.3337 8.66632C11.1872 8.51981 10.9885 8.4375 10.7812 8.4375C10.574 8.4375 10.3753 8.51981 10.2288 8.66632C10.0823 8.81284 10 9.01155 10 9.21875Z",
    fill: "#F5B544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.168 16.1113L13.5996 6.875V3.47656H15V2.14844H5V3.47656H6.40039V6.875L2.83203 16.1113C2.77734 16.2559 2.74805 16.4082 2.74805 16.5625C2.74805 17.252 3.30859 17.8125 3.99805 17.8125H16.002C16.1562 17.8125 16.3086 17.7832 16.4531 17.7285C17.0977 17.4805 17.418 16.7559 17.168 16.1113ZM7.72852 7.12305V3.51562H12.2715V7.12305L14.0469 11.7188C13.6426 11.6152 13.2246 11.5625 12.7988 11.5625C11.6035 11.5625 10.4707 11.9824 9.57031 12.7344C8.9082 13.2852 8.08008 13.5918 7.20117 13.5918C6.5625 13.5918 5.94922 13.4297 5.4082 13.1289L7.72852 7.12305ZM4.11133 16.4844L4.92578 14.3789C5.62305 14.7324 6.39844 14.9219 7.20312 14.9219C8.39844 14.9219 9.53125 14.502 10.4316 13.75C11.0937 13.1992 11.9219 12.8926 12.8008 12.8926C13.4844 12.8926 14.1367 13.0781 14.707 13.4219L15.8887 16.4844H4.11133Z",
    fill: "#F5B544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSymozxSelected);
export default __webpack_public_path__ + "static/media/menu_SYMOZX_selected.1b5d717a902d19c91d4190a0ac84fb66.svg";
export { ForwardRef as ReactComponent };